/**
 * Normaliza fechas de caducidad de lote (API: ISO, SQL, solo fecha).
 */
export function formatLineBatchDate(value: string | null | undefined): string {
  if (value == null || !String(value).trim()) return '';
  const raw = String(value).trim();
  const parsed = new Date(raw.includes('T') ? raw : raw.replace(' ', 'T'));
  if (Number.isNaN(parsed.getTime())) return raw;
  return parsed.toLocaleDateString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}
